const showSelfportrait = () => {

	let website = document.querySelector('.website'),
		websiteTextMb = document.querySelector('.website-text-mb'),
		bodyBg = document.querySelector('body'),
		header = document.querySelector('.header'),
		logo = document.querySelector('.header .logo'),
		logoImg = document.querySelectorAll('.header .logo img'),
		lines = document.querySelectorAll('.header .fence .line'),
		menuLinks = document.querySelectorAll('header .header .menu .dropdown li a'),
		design = document.querySelectorAll('.design'),
		languagesLinks = document.querySelectorAll('header .languages a'),
		selected = document.querySelectorAll('.selected'),		

		mainURL_EN = document.location.protocol + '//' + document.location.host + '/site',
		mainURL_RU = document.location.protocol + '//' + document.location.host + 'ru/site';			

	if (design)	{		

		design.forEach(function(item) {
			item.addEventListener('click', (e) => {

				e.preventDefault();

				websiteTextMb.classList.add('hide');
				website.classList.add('hide');
				bodyBg.style.backgroundImage = `url('/img/site_bg.jpg?ver=${Math.random([0, 1000])}')`;
				bodyBg.style.animation = 'fadeIn 0.5s';
				bodyBg.style.backgroundSize = 'cover';
				bodyBg.style.backgroundRepeat = 'no-repeat';
				bodyBg.style.backgroundPosition = 'center';
				header.style.backgroundColor = 'transparent';
				header.style.color = '#999';
				logoImg[0].style.display = 'block';				

				if (document.location.href == mainURL_EN) {

					logoImg[1].src = '/img/logo-white.png';		

				} else {

					logoImg[1].src = '/img/ru_logo-white.png';	
				}				

				lines.forEach(function(item, index, array) {					
					item.style.backgroundColor = '#ffffffc4';
				});
				selected.forEach(function(item, index, array) {					
					item.classList.add('selected-page-site');
				});
				menuLinks.forEach(function(item) {					
					item.addEventListener('mouseover', (e) => {
						item.style.color = '#ffffffc4';
					});
					item.addEventListener('mouseout', (e) => {
						item.style.color = '#999';
					});
				});
				languagesLinks.forEach(function(item) {					
					item.addEventListener('mouseover', (e) => {
						item.style.color = '#ffffffc4';
					});
					item.addEventListener('mouseout', (e) => {
						item.style.color = '#999';
					});
				});

			});
		});
	}
}
export default showSelfportrait;